import PropTypes from 'prop-types';
import React from 'react';

class Spacer extends React.PureComponent {
    static propTypes = {
        height: PropTypes.number.isRequired,
    };

    render() {
        return <div style={{ height: this.props.height, flexShrink: 0 }} />;
    }
}

export default Spacer;
